import { RespuestaEstructuraEmpresa } from "../modelo/EstructuraEmpresa";

export const CONSULTAR_ESTRUCTURA_EMPRESA = "CONSULTAR_ESTRUCTURA_EMPRESA";
export const ESTRUCTURA_EMPRESA_CONSULTADA = "ESTRUCTURA_EMPRESA_CONSULTADA";
export const ERROR_CONSULTANDO_ESTRUCTURA_EMPRESA = "ERROR_CONSULTANDO_ESTRUCTURA_EMPRESA";

export const consultarEstructuraEmpresa = (dniEmpleador: string, consecutivoConsulta: number, usuario: string) =>
    ({ type: CONSULTAR_ESTRUCTURA_EMPRESA, dniEmpleador, consecutivoConsulta, usuario });
export const estructuraEmpresaConsultada = (respuestaEstructuraEmpresa: RespuestaEstructuraEmpresa, mensajeRespuesta: string) =>
    ({ type: ESTRUCTURA_EMPRESA_CONSULTADA, respuestaEstructuraEmpresa, mensajeRespuesta });
export const errorConsultandoEstructuraEmpresa = () => ({ type: ERROR_CONSULTANDO_ESTRUCTURA_EMPRESA });


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/modulos/estructuraEmpresasActions.ts